import AppTemplatesImage from '@/images/Products/app-templates.png';
import VisualAppBuilderImage from '@/images/Products/visual-app-builder.png';
import InBrowserAppPreviewImage from '@/images/Products/in-browser-apps-preview.png';
import CMS from '@/images/Products/cms.png';
import ContinuousIntegrationImage from '@/images/Products/continuous-integration.png';
import ScreenshotsGeneratorImage from '@/images/Products/screenshots-generator.png';
import AppLandingPageImage from '@/images/Products/app-landing-page.png';
import StoreManagerImage from '@/images/Products/store-manager.png';
import BackendAsAServiceImage from '@/images/Products/backend-as-a-service.png';
import TermsAndPolicesGeneratorImage from '@/images/Products/terms-and-policies-generator.png';
import CodeplatformAI from '@/images/Products/codeplatform-ai.png';

import AppTemplates0 from '@/images/Products/app-templates-0.png';
import AppTemplates1 from '@/images/Products/app-templates-1.png';
import AppTemplates2 from '@/images/Products/app-templates-2.png';
import VisualAppBuilder0 from '@/images/Products/visual-app-builder-0.png';
import VisualAppBuilder1 from '@/images/Products/visual-app-builder-1.png';
import VisualAppBuilder2 from '@/images/Products/visual-app-builder-2.png';
import VisualAppBuilder3 from '@/images/Products/visual-app-builder-3.png';
import InBrowserAppPreview0 from '@/images/Products/in-browser-apps-preview-0.png';
import InBrowserAppPreview1 from '@/images/Products/in-browser-apps-preview-1.png';
import CMS0 from '@/images/Products/cms-0.png';
import CMS1 from '@/images/Products/cms-1.png';
import CMS2 from '@/images/Products/cms-2.png';
import ContinuousIntegration0 from '@/images/Products/continuous-integration-0.png';
import ContinuousIntegration1 from '@/images/Products/continuous-integration-1.png';
import ContinuousIntegration2 from '@/images/Products/continuous-integration-2.png';
import ScreenshotsGenerator0 from '@/images/Products/screenshots-generator-0.png';
import ScreenshotsGenerator1 from '@/images/Products/screenshots-generator-1.png';
import ScreenshotsGenerator2 from '@/images/Products/screenshots-generator-2.png';
import AppLandingPage0 from '@/images/Products/app-landing-page-0.png';
import AppLandingPage1 from '@/images/Products/app-landing-page-1.png';
import AppLandingPage2 from '@/images/Products/app-landing-page-2.png';
import AppLandingPage3 from '@/images/Products/app-landing-page-3.png';
import StoreManager0 from '@/images/Products/store-manager-0.png';
import StoreManager1 from '@/images/Products/store-manager-1.png';
import StoreManager2 from '@/images/Products/store-manager-2.png';
import BackendAsAService0 from '@/images/Products/backend-as-a-service-0.png';
import BackendAsAService1 from '@/images/Products/backend-as-a-service-1.png';
import BackendAsAService2 from '@/images/Products/backend-as-a-service-2.png';
import BackendAsAService3 from '@/images/Products/backend-as-a-service-3.png';
import TermsAndPolicesGenerator0 from '@/images/Products/terms-and-policies-generator-0.png';
import TermsAndPolicesGenerator1 from '@/images/Products/terms-and-policies-generator-1.png';
import TermsAndPolicesGenerator2 from '@/images/Products/terms-and-policies-generator-2.png';
import CodeplatformAI0 from '@/images/Products/codeplatform-ai-0.png';
import CodeplatformAI1 from '@/images/Products/codeplatform-ai-1.png';
import CodeplatformAI2 from '@/images/Products/codeplatform-ai-2.png';
import CodeplatformAI3 from '@/images/Products/codeplatform-ai-3.png';

import { Links, ProductLinks } from '@/utils/constants';
import { Name } from '@/components/general';

export interface ICard {
  title: string;
  titleMaxWidth?: number;
  description: string;
  image?: any;
  imageWidth?: number;
  aspectHeight?: number;
  imageHeight?: number;
  linkReg?: RegExp;
  links?: Links | ProductLinks | string[];
}

export interface IProduct {
  title: string;
  description: string;
  icon: Name;
  image: any;
  to?: string;
  cards?: ICard[];
}

export const PRODUCTS: IProduct[] = [
  {
    title: 'App Templates',
    description:
      'Well-architected iOS Swift & Android Kotlin project templates bundled into pre-built modules',
    icon: Name.PRODUCTS_APP_TEMPLATES,
    image: AppTemplatesImage,
    to: '/templates',
    cards: [
      {
        title: 'Stop writing boilerplate code.',
        description:
          'The hardest parts of mobile applications developed for you. Select an app starter or fully completed iOS Swift & Android Kotlin project template. Adjust your branding, texts and resources in a Visual App Builder or continue as a professional developer with Github. Preview the result in browser.',
        image: AppTemplates0,
        aspectHeight: 0.96,
        linkReg: /(in browser)/g,
        links: [ProductLinks.BROWSER],
      },
      {
        title: 'Everything you need in one place.',
        description:
          'Swift and Kotlin native apps, serverless backend and app landing page pipelines are prepared for you. Save your time with all DevOps ready.',
        image: AppTemplates1,
        linkReg: /(serverless backend|app landing page|DevOps ready)/g,
        links: [
          ProductLinks.BACKEND,
          ProductLinks.APP_LANDING,
          ProductLinks.CONTINUOUS,
        ],
      },
      {
        title: 'Get ready to launch. Publishing made easy.',
        description:
          'Generate and control everything form app landing page to screenshots, to terms & policies - all in one place with Store Manager',
        image: AppTemplates2,
        linkReg:
          /(app landing page|screenshots|terms & policies|Store Manager)/g,
        links: [
          ProductLinks.APP_LANDING,
          ProductLinks.SCREENSHOTS,
          ProductLinks.TERMS,
          ProductLinks.STORE,
        ],
      },
    ],
  },
  {
    title: 'Visual App Builder',
    description:
      'A low-code way to tune your app template and update the source code',
    icon: Name.PRODUCTS_VISUAL_APP_BUILDER,
    image: VisualAppBuilderImage,
    cards: [
      {
        title: 'Design visually. Start building your MVP with no-code tools.',
        titleMaxWidth: 530,
        description:
          'Adjust your app templates branding, texts and resources. Check screen sequences and preview the result in browser.',
        image: VisualAppBuilder0,
        linkReg: /(app templates|in browser)/g,
        links: [Links.TEMPLATES, ProductLinks.BROWSER],
      },
      {
        title: 'Own the source code. Continue in a low-code way.',
        description:
          'No need to start from scratch after the no-code MVP. Connect to GitHub and add your next killer features by extending the source code, or ask our experts to develop them.',
        image: VisualAppBuilder1,
        aspectHeight: 0.96,
        linkReg: /(our experts)/g,
        links: [Links.TALK],
      },
      {
        title: 'Build and deploy everything you need. No additional DevOps.',
        titleMaxWidth: 450,
        description:
          'Swift and Kotlin native apps, backend and landing page pipelines are prepared for you. Save your time with all DevOps ready.',
        image: VisualAppBuilder2,
      },
      {
        title: 'Get ready to launch. Publishing made easy.',
        description:
          'Generate and control everything form app landing page to screenshots, to terms & policies - all in one place with Store Manager',
        image: VisualAppBuilder3,
        linkReg:
          /(app landing page|screenshots|terms & policies|Store Manager)/g,
        links: [
          ProductLinks.APP_LANDING,
          ProductLinks.SCREENSHOTS,
          ProductLinks.TERMS,
          ProductLinks.STORE,
        ],
      },
    ],
  },
  {
    title: 'In-Browser Apps preview',
    description:
      'Preview native apps in browser without opening Xcode or Android Studio',
    icon: Name.PRODUCTS_IN_BROWSER_APP_PREVIEW,
    image: InBrowserAppPreviewImage,
    cards: [
      {
        title: 'Run native mobile apps in your browser.',
        titleMaxWidth: 468,
        description:
          "We will build a native app preview for you using our Continuous Integration system - you don't need to install the app to play with it.",
        image: InBrowserAppPreview0,
        imageHeight: 536,
        imageWidth: 266,
        linkReg: /(Continuous Integration)/g,
        links: [ProductLinks.CONTINUOUS],
      },
      {
        title: 'Promote your app directly to app stores.',
        description:
          'Trigger Testflight and Google Play build in a single click. Store Manager will cover the rest.',
        image: InBrowserAppPreview1,
        linkReg: /(Store Manager)/g,
        links: [ProductLinks.STORE],
      },
    ],
  },
  {
    title: 'Content Management System',
    description:
      'Headless CMS for your app with content models and digital assets management',
    icon: Name.PRODUCTS_CMS,
    image: CMS,
    cards: [
      {
        title: 'Content models and digital assets management',
        titleMaxWidth: 541,
        description:
          'CCompose your data in one spot. Add records and create collections in a user-friendly CMS.',
        image: CMS0,
      },
      {
        title: 'Unified data collections form various sources',
        titleMaxWidth: 540,
        description:
          'Just select and connect your own data source or design your collections from scratch',
        image: CMS1,
      },
      {
        title: 'Everything stays in sync',
        titleMaxWidth: 541,
        description:
          'Display your data straight in your app. Bind it visually in Visual App Builder. Everything is synchronized automatically.',
        image: CMS2,
      },
    ],
  },
  {
    title: 'Continuous Integration',
    description:
      'Build and deploy everything your app needs. No additional DevOps',
    icon: Name.PRODUCTS_CONTINIOUS_INTEGRATION,
    image: ContinuousIntegrationImage,
    cards: [
      {
        title: 'Forget about complex DevOps.',
        titleMaxWidth: 582,
        description:
          'Focus on features development. Let us prepare boilerplate code, its repositories and CI/CD pipelines for you.',
        image: ContinuousIntegration0,
      },
      {
        title: 'Build everything you need in one place.',
        description:
          'Swift and Kotlin native apps, serverless backend, app landing page and its pipelines are prepared for you.',
        image: ContinuousIntegration1,
        linkReg: /(serverless backend|app landing page)/g,
        links: [ProductLinks.BACKEND, ProductLinks.APP_LANDING],
      },
      {
        title: 'Deploy and publish easily.',
        titleMaxWidth: 560,
        description:
          'Deploy your serverless backend and app landing page. Test and preview your builds. Upload them to Testflight and Google Play automatically with Store Manager.',
        image: ContinuousIntegration2,
        linkReg: /(serverless backend|app landing page|preview|Store Manager)/g,
        links: [
          ProductLinks.BACKEND,
          ProductLinks.APP_LANDING,
          ProductLinks.BROWSER,
          ProductLinks.STORE,
        ],
      },
    ],
  },
  {
    title: 'Screenshots Generator',
    description:
      'A professional app store screenshots editor. Create eye-catching screenshots and get more downloads',
    icon: Name.PRODUCTS_SCREENSHOTS_GENERATOR,
    image: ScreenshotsGeneratorImage,
    cards: [
      {
        title: 'Professional app store screenshots editor.',
        titleMaxWidth: 427,
        description:
          'Create panoramic studio-quality screenshots for iOS and Android apps in a few clicks.',
        image: ScreenshotsGenerator0,
        aspectHeight: 0.963,
      },
      {
        title: 'Eye-catching screenshots templates.',
        description:
          'Get more downloads using ASO screenshots templates. Best practices to make your screenshots catch the eye of users and  increase in-app conversions.',
        image: ScreenshotsGenerator1,
        imageHeight: 520,
        imageWidth: 462,
      },
      {
        title: "No more monkey job. It's automated.",
        titleMaxWidth: 400,
        description:
          'Screenshots are updated automatically with your app, including Store Manager and App Landing page. No need to recreate them manually every time.',
        image: ScreenshotsGenerator2,
        linkReg: /(Store Manager|App Landing page)/g,
        links: [ProductLinks.STORE, ProductLinks.APP_LANDING],
      },
    ],
  },
  {
    title: 'App Landing Page',
    description:
      'Get your own appstore-optimized application homepage with all the necessary content',
    icon: Name.PRODUCTS_APP_LANDING_PAGE,
    image: AppLandingPageImage,
    cards: [
      {
        title: 'Automated App Landing Page',
        description:
          'Get the application homepage with everything required by app stores. It is updated simultaneously with you app.',
        image: AppLandingPage0,
      },
      {
        title: 'Terms & Policies generated for you',
        description:
          'Humanly understandable terms and policies generated and tailored towards your app. The page with terms & policies is linked to your apps and app stores via Store Manager.',
        image: AppLandingPage1,
        linkReg: /(Store Manager)/g,
        links: [ProductLinks.STORE],
      },
      {
        title: 'Contact form as-a-service ',
        description:
          'A universal way to collect feature requests and bugs, as well as communicate with your users - all while complying with app stores requirements.',
        image: AppLandingPage2,
      },
      {
        title: 'SEO-optimized. Multilingual. Maximum performance.',
        description:
          'App landing page designed using best practices in SEO and PageSpeed Insights. Built on React Next.js with Static Site Generation option enabled. And yes, you can extend it by modifying the source code.',
        image: AppLandingPage3,
        linkReg: /(source code)/g,
        links: [Links.TEMPLATES],
      },
    ],
  },
  {
    title: 'Store Manager',
    description:
      'Publishing process made easy. Generate and control app stores content all in one place',

    icon: Name.PRODUCTS_STORE_MANAGER,
    image: StoreManagerImage,
    cards: [
      {
        title: 'Manage store content in one place',
        description:
          'Connect App Store and Google Play with a simple integration. We will do all the hidden job to help you with publishing.',
        image: StoreManager0,
        imageHeight: 530,
        imageWidth: 560,
      },
      {
        title: "No more monkey job. It's automated.",
        description:
          'We will build your app and prepare everything necessary to publish - all the links to product page,  terms & policies, support page and screenshots will be pre-filled in advance.',
        image: StoreManager1,
        linkReg: /(build your app)/g,
        links: [ProductLinks.CONTINUOUS],
      },
      {
        title: 'Faster time to market',
        description:
          'We have covered all the main pitfalls in publishing process. You can use this time to polish your product instead.',
        image: StoreManager2,
      },
    ],
  },
  {
    title: 'Backend-as-a-service',
    description:
      'Generate and deploy serverless app backend in a click. Pay as you go',
    icon: Name.PRODUCTS_BACKEND_AS_A_SERVICE,
    image: BackendAsAServiceImage,
    cards: [
      {
        title: 'Backend for your project out of the box.',
        titleMaxWidth: 468,
        description:
          'Security comes first. Best practices used for authentication, encryption, end-to-end communication, sensitive data storing, API protection, error tracking and performance monitoring.',
        image: BackendAsAService0,
      },
      {
        title: "Don't worry about scalability. It's serverless.",
        description:
          'We use serverless architecture and modern Infrastructure-as-a-Service solutions that scale automatically. No maintenance expenses. Pay as you go.',
        image: BackendAsAService1,
        imageHeight: 470,
        imageWidth: 491,
      },
      {
        title: 'Own the source code and infrastructure.',
        description:
          'We run isolated Google Cloud projects and are able transfer them to your account when you are ready. No lock-ins on our services.',
        image: BackendAsAService2,
        imageHeight: 410,
        imageWidth: 421,
      },
      {
        title: 'Custom integrations made simple.',
        description:
          'Extend the backend with a new API endpoint or a webhook visually, or by updating the source code. Ask our experts if you need a unique custom feature development or integration. We would be happy to help with your next project as well as step-by-step legacy app migration.',
        image: BackendAsAService3,
        linkReg: /(Ask our experts)/g,
        links: [Links.TALK],
      },
    ],
  },
  {
    title: 'Terms & Policies Generator',
    description:
      'A wizard to create humanly understandable terms and policies for your app',
    icon: Name.PRODUCTS_TERMS_AND_POLICES_GENERATOR,
    image: TermsAndPolicesGeneratorImage,
    cards: [
      {
        title: 'Compliance solutions out of the box.',
        description:
          'Get your documents and make your app compliant in minutes with terms and policies wizard.',
        image: TermsAndPolicesGenerator0,
        imageWidth: 490,
      },
      {
        title: 'US / EU Privacy Law Coverage',
        description:
          'Privacy Policy, Terms and Conditions, EULA, Disclaimer and more for mobile iOS & Android apps.',
        image: TermsAndPolicesGenerator1,
      },
      {
        title: "No more monkey job. It's automated.",
        titleMaxWidth: 400,
        description:
          'Terms & policies are updated automatically with your app, including Store Manager and App Landing page. No need to recreate them every time.',
        image: TermsAndPolicesGenerator2,
        linkReg: /(Store Manager|App Landing page)/g,
        links: [ProductLinks.STORE, ProductLinks.APP_LANDING],
      },
    ],
  },
  {
    title: 'CodePlatform AI',
    description:
      'Generate code, assets and appstores content with AI in seconds',
    to: '/ai',
    icon: Name.PRODUCTS_CODEPLATFORM_AI,
    image: CodeplatformAI,
    cards: [
      {
        title: 'Build visually with AI co-pilot',
        description:
          'Prompt AI co-pilot to generate an app, a single screen or app assets and more.',
        image: CodeplatformAI0,
      },
      {
        title: 'Get complete source code',
        description:
          'Complete source code of Swift and Kotlin native apps, Serverless backend and App landing page is generated for you. Connect your GitHub to manage it.',
        image: CodeplatformAI1,
        imageHeight: 414,
        linkReg: /(Serverless backend|App landing page)/g,
        links: [ProductLinks.BACKEND, ProductLinks.APP_LANDING],
      },
      {
        title: 'Forget about complex DevOps',
        description:
          'Focus on features development. Let us prepare repositories nd CI/CD pipelines for you.',
        image: CodeplatformAI2,
        imageWidth: 456,
      },
      {
        title: 'Get ready to launch -publishing made easy',
        description:
          'Generate and control everything form App landing page to Screenshots, to Terms & Policies - all in one place with Store Manager',
        image: CodeplatformAI3,
        imageWidth: 456,
        linkReg: /(App landing page|Screenshots|Terms & Policies)/g,
        links: [
          ProductLinks.APP_LANDING,
          ProductLinks.SCREENSHOTS,
          ProductLinks.TERMS,
        ],
      },
    ],
  },
];
